<p>
  Use to display structured content inside a Material card with optional header actions, edit mode, expandable content, and footer actions.
</p>

<h2>Use When</h2>
<ul>
  <li>Grouping related content into a clear card layout</li>
  <li>Displaying readonly or editable form sections</li>
  <li>Allowing users to expand or collapse a section</li>
  <li>Providing contextual header actions such as edit or additional actions</li>
</ul>

<h2>Behavior</h2>
<ul>
  <li>Supports an optional title in the card header</li>
  <li>Supports expandable and collapsible content</li>
  <li>Shows an edit button when the card is not readonly and not already in edit mode</li>
  <li>Shows save and cancel actions when the card is in edit mode</li>
  <li>Supports an optional additional action button in the header</li>
  <li>Allows rendering cards with or without a title</li>
</ul>

<p>
  Import the
  <app-text-code>CardComponent</app-text-code>
  in your app.module.ts and use it via
  <app-text-code>&lt;mad-card&gt;</app-text-code>
  .
</p>

<p>Basic editable card example</p>
<example-viewer [example]="cardEditableComponent"></example-viewer>

<p>Readonly card example</p>
<example-viewer [example]="cardReadonlyComponent"></example-viewer>

<p>Expandable / collapsible card example</p>
<example-viewer [example]="cardExpandableComponent"></example-viewer>

<p>Editable card with reactive form content</p>
<example-viewer [example]="cardReactiveFormEditableComponent"></example-viewer>

<p>Card without title</p>
<example-viewer [example]="cardWithoutTitleComponent"></example-viewer>

<h2>API Specification</h2>
<app-card-demo-api-spec></app-card-demo-api-spec>
